import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { PopupComponent } from './popup/popup.component';

@NgModule({
    exports: [
        PopupComponent

    ],
    imports: [CommonModule,
      BrowserModule
    ],
    providers: [
        
    ],
    declarations: [

    
    PopupComponent
  ]
})
export class SharedModule { }
